import { render, staticRenderFns } from "./inviteForm.vue?vue&type=template&id=5359e856&scoped=true"
import script from "./inviteForm.vue?vue&type=script&lang=js"
export * from "./inviteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5359e856",
  null
  
)

export default component.exports